module.exports = __webpack_public_path__ + "static/kategorier-se-d81df5dc10fc8eaeee017992b5c79963.png";